import React, { useEffect, useState } from 'react';

// Components
import * as S from './Styled';
import { useLang } from '../../context/lang';

// Utils
import { useTranslation } from 'react-i18next';

// Config
import locale from '../../config/locale';
import { fetchBrowserGeo } from '../../utils/map';
import toast from '../../utils/toast';
import { selectLocation } from '../../actions';
import { useDispatch } from 'react-redux';
import localStorage from 'store';

const LangSwitcher = () => {
  const { language, onSetLanguage } = useLang();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const items = Object.keys(locale).filter(i => i !== language);
    setItems(items);
  }, [language]);

  const handleSelectCity = async item => {
    let payload = {
      ...item,
      name: item?.address?.split(',')?.[0] ?? item?.name,
    };
    await dispatch(selectLocation(payload));
  };

  const handleFetchBrowserGeo = async () => {
    try {
      let data = await fetchBrowserGeo();
      handleSelectCity(data);
    } catch (e) {
      toast.error({
        message: t('messages.errors.get_browser_error'),
        placement: 'bottomRight',
      });
      console.error(e);
    }
  };

  const clearAndDetectLocationSettings = () => {
    localStorage.remove('location_confirmed');
    localStorage.remove('user_location');
    handleFetchBrowserGeo();
  };

  const changeLanguage = async value => {
    await onSetLanguage(value);
    await i18n.changeLanguage(value);
    clearAndDetectLocationSettings();
  };

  return (
    <S.Switcher>
      <S.Label>{t('labels.language')}</S.Label>
      <S.Divider />
      <S.List>
        {items.map(item => (
          <S.Link key={item} onClick={() => changeLanguage(item)}>
            {locale[item].label}
          </S.Link>
        ))}
      </S.List>
    </S.Switcher>
  );
};

export default LangSwitcher;
